// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c0857d07","389":"1d4eaf94","732":"c29f06b7","977":"24fda54d"}[chunkId] + ".chunk.js";
};